import DefaultConfirmDeletion from './default'
import MultipleConfirmDeletion from './multiple'

export {
  DefaultConfirmDeletion,
  MultipleConfirmDeletion,
}
